export default __webpack_public_path__ + "static/media/error404.fb95c0eb.svg";